// extracted by mini-css-extract-plugin
export default {"style":"SupprimerProjetFavori_style__zn3OF"};